let selected = function(val){
	this.selectedTr();
};
export default selected;
